import axios from 'axios';
import { NUMBER_OF_POST_ORDER_API_RETRIES, POST_ORDER_API_EXPONENTIAL_DELAY } from 'core/constants/checkout.constants';
import { CLIENT_OFFLINE_NETWORK_ERROR_CODE } from 'core/constants/error-http.constants';
import { https } from 'core/services/https';
import { generateUUIDv4 } from 'shared/utils/uuid.utils';
import {
  ICreateOrderRequestParams,
  IGetOrderDetailDTO,
  IGetOrderParams,
  IGetOrdersDTO,
  IOrderCreatedResponseDTO,
} from './orders.dto';

const baseUrl = '/v1/orders';

export const ordersData = {
  createOrder: async (
    body: ICreateOrderRequestParams,
    customerId: number,
    uuid?: string,
  ): Promise<IOrderCreatedResponseDTO> => {
    const idempotencyKey = uuid ?? generateUUIDv4();
    const data = await https.post<IOrderCreatedResponseDTO>(baseUrl, body, {
      headers: {
        'Gtm-Idempotency-Key': idempotencyKey,
        'Gtm-Customer-id': customerId,
      },
      'axios-retry': {
        retries: NUMBER_OF_POST_ORDER_API_RETRIES,
        retryDelay: count => count * POST_ORDER_API_EXPONENTIAL_DELAY,
        retryCondition: error => axios.isAxiosError(error) && error.code === CLIENT_OFFLINE_NETWORK_ERROR_CODE,
      },
    });

    return data;
  },

  getOrders: async (params: IGetOrderParams, customerId: number): Promise<IGetOrdersDTO> => {
    const data = await https.get<IGetOrdersDTO>(baseUrl, {
      params,
      headers: {
        'Gtm-Customer-id': customerId,
      },
    });

    return data;
  },

  getOrderDetail: async (orderId: string, sourceId: number, customerId: number): Promise<IGetOrderDetailDTO> => {
    const data = await https.get<IGetOrderDetailDTO>(`${baseUrl}/${orderId}`, {
      params: { sourceId },
      headers: {
        'Gtm-Customer-id': customerId,
      },
    });

    return data;
  },
};
